// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__KHdDD","options":"AnswerScale_options__3VvxH","selected":"AnswerScale_selected__1yhHE"};